import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Bullseye, ChatFill, Cursor, CursorFill, Whatsapp } from 'react-bootstrap-icons'
import Authentication from '../../../../../../libs/api/services/Authentication'
import MessagingService from '../../../../../../libs/api/services/MessagingService'
import MessagingServiceProvider from '../../../../../../libs/api/services/MessagingServiceProvider'
import { ClaimsFilter } from '../../../../../../libs/authentication/ClaimsFilter'
import CommonFunctionsContext from '../../../../../common/CommonFunctionsProvider'
import RTEMessageBuilderComponent from '../../../admin/components/RTEMessageBuilderComponent'
import SendTo from './SendTo'

const ServiceTypeOptions = {
    'Internal Messaging Service': ['fontSize', 'inline', 'textAlign', 'emoji'],
    'SMS': ['emoji'],
    'WhatsApp': ['emoji'],
    'Email': ['fontSize', 'inline', 'textAlign', 'emoji'],
}
export default function NewMessageModal({ close, type }) {
    const { showToast } = useContext(CommonFunctionsContext)
    const [error, setError] = useState()
    const [message, setMessage] = useState(
        {
            userType: undefined,
            serviceType: undefined,
            serviceProvider: undefined,
            recipients: [],
            messageBody: undefined,
            status: 'Send',
            subject: undefined
        })

    const _handleSendMessage = () => {
        setMessage({ ...message, status: 'Sending' })
        // console.log(message)
        MessagingService
            .SendMessage(message)
            .then((r) => {
                close(() => showToast(<div className='animate__animated animate__tada animate__delay-2s'><b> Message Sent</b></div>, <CursorFill />, 7))
                // setMessage({ ...message, status: 'Sent' })
            }).catch((e) => {
                setMessage({ ...message, status: 'Failed' })
                setError(e.message)
            })
    }
    return (
        <div className='text-dark d-flex flex-column h-100 m-3'>
            <div className='flex-shrink-1'>
                {error && <div className='bg-danger-container p-2 shadow rounded m-2 text-center'>{error}</div>}
                <div className='flex-shrink-1'>
                    <SendUsingOptions type={type} onChange={t => setMessage({ ...message, ...t, recipients: [] })} />
                </div>
                {
                    message.serviceType &&
                    <div className='flex-shrink-1'>
                        <SendTo ServiceType={message.serviceType}
                            //errors={errors} 
                            onChange={(r) => setMessage({ ...message, recipients: r })}
                        />
                    </div>
                }
                {
                    message.recipients.length > 0 &&
                    <div className='flex-shrink-1'>
                        <b>Subject</b>
                        <input onChange={(e) => setMessage({ ...message, subject: e.target.value })} className='form-control form-control-sm' placeholder='Subject' />
                    </div>
                }
            </div>
            <div className='flex-grow-1 h-100' style={{ overflow: 'auto' }}>
                {
                    // message.recipients.length === 0 && !message.serviceProvider &&
                    message.serviceType &&
                    <>
                        <b>Message</b>
                        <RTEMessageBuilderComponent
                            disablePlaceholders={true}
                            placeholders={false}
                            onSetTemplate={(t, h, m) => setMessage({
                                ...message, messageBody: {
                                    template: t,
                                    html: h,
                                    markdown: m.replaceAll('**', '')
                                }
                            })}
                            options={ServiceTypeOptions[message.serviceType]}
                            viewOnly={false} />
                    </>
                }
            </div>
            <div className='flex-shrink-1 d-flex justify-content-end'>
                <button
                    onClick={() => _handleSendMessage()}
                    className={'btn bg-secondary-container '.concat(message.recipients.length === 0 ? 'disabled' : '')}>{message.status}</button>
            </div>

            {/* <div className='flex-shrink-1'>
                {
                    message.userType === 'Patient'
                        ?
                        <></>
                        :
                        <SendUsingOptions onChange={(d) => setMessage({ ...message, ...d, recipients: [] })} />
                }

            </div>
            <div className='flex-shrink-1'>
                {
                    message.serviceType
                        ?
                        <SendTo ServiceType={message.serviceType} errors={errors} onChange={(r) => setMessage({ ...message, recipients: r })} />
                        :
                        <></>
                }

            </div>
            <div className='flex-shrink-1'>
                {
                    message.recipients.length > 0
                        ?
                        <>
                            <b>Subject</b>
                            <input onChange={(e) => setMessage({ ...message, subject: e.target.value })} className='form-control form-control-sm' placeholder='Subject' />
                        </>
                        :
                        <></>
                }

            </div>
            <div className='flex-grow-1 h-100' style={{ overflow: 'auto' }}>
                {
                    message.recipients.length === 0 && !message.serviceProvider
                        ?
                        <></>
                        :
                        <>
                            <b>Message</b>
                            <RTEMessageBuilderComponent
                                disablePlaceholders={true}
                                placeholders={false}
                                onSetTemplate={(t, h, m) => setMessage({
                                    ...message, messageBody: {
                                        template: t,
                                        html: h,
                                        markdown: m.replaceAll('**', '')
                                    }
                                })}
                                options={messageOptions}
                                viewOnly={false}
                            />
                        </>
                }

            </div>
            <div className='flex-shrink-1 d-flex justify-content-end'>
                <btton onClick={() => _handleSendMessage()} className={'btn bg-secondary-container '.concat(message.recipients.length === 0 ? 'disabled' : '')}>{message.status}</btton>
            </div> */}
        </div>
    )
}


const SendUsingOptions = ({ onChange, type }) => {
    const [state, setState] = useState({
        serviceTypes: [
            { type: 'Internal Messaging Service', icon: <Bullseye size={18} className='me-2' /> },
            { type: 'SMS', icon: <ChatFill size={18} className='me-2' /> },
            { type: 'WhatsApp', icon: <Whatsapp size={18} className='me-2' /> },
            { type: 'Email', icon: <Cursor size={18} className='me-2' /> },
        ],
        selectedServiceType: { type: undefined },
        serviceProviders: undefined,
        selectedServiceProvider: undefined
    })
    useEffect(() => {
        onChange({
            serviceType: state.selectedServiceType.type,
            serviceProvider: state.selectedServiceProvider,
        })
    }, [state])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const load = async () => {
            setLoading(true)
            const Providers = await MessagingServiceProvider
                .ListAvailableServiceProviders(Authentication.UserId(), Authentication.getFacility(), state.selectedServiceType.type)
            setState({
                ...state,
                serviceProviders: Providers,
                selectedServiceProvider: Providers.length === 1 ? Providers[0].id : undefined
            })
            setLoading(false)
        }
        if (!['Internal Messaging Service', undefined].includes(state.selectedServiceType.type))
            load(state.selectedServiceType)
    }, [state.selectedServiceType])
    return (
        <>
            <div className='d-flex'>

                {state.serviceTypes && state.serviceTypes.map(s =>
                    <ClaimsFilter resources={[{ resource: `Messages|${type}|${s.type}`, type: 'Edit' }]} claim={[]}>
                        <button onClick={e => setState({ ...state, selectedServiceType: s, serviceProviders: undefined })} key={`${s.type}`}
                            className={`btn ${state.selectedServiceType && state.selectedServiceType.type === s.type && 'bg-primary-container'} w-100 d-flex justify-content-center align-items-center`}>{s.icon} {s.type}</button>
                    </ClaimsFilter>
                )}
            </div>
            {state.serviceProviders && typeof state.serviceProviders !== 'undefined' && (
                {
                    0: <div className='bg-warning-container p-2 shadow rounded m-2 text-center'>{`There are no service providers to send this message`}</div>,
                    1: <div className='bg-success-container p-2 shadow rounded m-2 text-center'>{`Using Service Provider ${state.serviceProviders[0] && state.serviceProviders[0].name}`}</div>,
                }[state.serviceProviders.length] ||
                <select onChange={e => setState({ ...state, selectedServiceProvider: e.target.value })} className='form-control'>
                    <option></option>
                    {state.serviceProviders.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
            )}
            {loading && <div className='text-center'><FontAwesomeIcon icon={faSpinner} spin /></div>}
        </>)
}
